import EmblaCarousel from 'embla-carousel';
import ClassNames from 'embla-carousel-class-names';
import { setupProgressBar } from './progress-bar';
import type { EmblaOptionsType } from 'embla-carousel';

export class TeamSlider {
    emblaNode: HTMLElement | null = document.querySelector('.rider-slider.embla');
    emblaViewportNode: HTMLElement | null = document.querySelector('.embla__viewport');
    emblaPrevButtonNode: HTMLElement | null = document.querySelector('.embla__prev');
    emblaNextButtonNode: HTMLElement | null = document.querySelector('.embla__next');
    emblaProgressNode = document.querySelector<HTMLElement>('.embla__progress__bar')!;
    emblaOptions: EmblaOptionsType = { loop: true, align: 'start' };

    constructor() {
        if (!this.emblaNode || !this.emblaViewportNode || !this.emblaPrevButtonNode || !this.emblaNextButtonNode) {
            return;
        }
        const emblaApi = EmblaCarousel(this.emblaViewportNode, this.emblaOptions, [ClassNames()]);
        const { applyProgress, removeProgress } = setupProgressBar(
            emblaApi,
            this.emblaProgressNode
        )

        // Add click listeners
        this.emblaPrevButtonNode.addEventListener('click', () => emblaApi.scrollPrev(), false)
        this.emblaNextButtonNode.addEventListener('click', () => emblaApi.scrollNext(), false)

        emblaApi
            .on('init', applyProgress)
            .on('reInit', applyProgress)
            .on('scroll', applyProgress)
            .on('slideFocus', applyProgress)
            .on('destroy', removeProgress)
    }
}